// Copyright © 2019 3D Robotics. All rights reserved.

import React from 'react';

const NoMatchRoute = () => (
  <div>404 - The requested page could not be found</div>
);

export default NoMatchRoute;
